const DOCTOR_CONSTANTS = {
    LIST_DOCTOS: 'v1/doctors',
    GET_DOCTOR_DETAILS: 'v1/doctor'
};

export default DOCTOR_CONSTANTS;
